import { Stack, Modal, Icon, Box, CircularProgress } from "@mui/material";
import { Clear as ClearIcon } from "@mui/icons-material";

const ItemsListV2 = ({ items, itemsLoading, itemDetailed, closeDetailed }) => {
  return (
    <Stack spacing={2} sx={{ m: 1 }}>
      {itemDetailed ? (
        <Modal
          open={!!itemDetailed}
          sx={{
            zIndex: 1305,
          }}
        >
          <Box sx={{ height: "100dvh", overflowY: "auto" }}>
            <Icon
              onClick={closeDetailed}
              sx={{
                zIndex: 1306,
                // '&:hover': { cursor: 'pointer', backgroundColor: "#000", color: "#fff"},
                p: "5px",
                backgroundColor: "#eee",
                borderRadius: "50%",
                position: "absolute",
                top: "10px",
                right: "10px",
              }}
            >
              <ClearIcon />
            </Icon>
            {itemDetailed}
          </Box>
        </Modal>
      ) : null}
      {itemsLoading ? (
        <Box
          sx={{
            height: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <CircularProgress size={"30px"} aria-label="Loading…" />
        </Box>
      ) : (
        items
      )}
    </Stack>
  );
};

export default ItemsListV2;
